<h2 class="text-lg font-semibold px-3 sm:p-0 mt-3 sm:mt-1">Konditionsliste drucken</h2>

<div class="flex flex-col mt-3 px-3 sm:p-0">
    <div class="flex flex-col flex-1 w-full">
        <label class="soft-label top mb-1">Gültig ab</label>
        <soft-date-input [value]="valid_from" (valueChange)="valid_from = $event ?? ''" placeholder="Datum"></soft-date-input>
    </div>
    <div class="grid grid-cols-1 gap-4 sm:grid-cols-2 mt-4">
        <div class="flex flex-col">
            <label class="soft-label top mb-1">Layout</label>
            <soft-checkbox [value]="conditionSheet2" labelPosition="after">
                <span class="ml-3">Alternatives Layout</span>
            </soft-checkbox>
        </div>

        <div class="flex flex-col">
            <label class="soft-label top mb-1">Preise</label>
            <soft-checkbox [value]="includePrice" labelPosition="after">
                <span class="ml-3">Preise andrucken</span>
            </soft-checkbox>
        </div>
    </div>
</div>

<div class="flex w-full mt-4 sm:space-x-3">
    <button class="soft-button secondary w-1/2" (click)="close(null)">
        Abbrechen
    </button>
    <button class="soft-button primary w-1/2" (click)="closeAndPrint()">
        Drucken
    </button>
</div>
